import { $ABTest } from '@lemon8/webapp-shared/model';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';
import { $PageLevelTraffic } from 'shared/atoms';
import { EPageType } from 'shared/models';

/**
 * 0: control group
 * 1: forward the positions of hashtag big card
 */
export const $SEOKepHashtagPosExp: Atom<number> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return 1;
  }
  return _get(parameters, ['seo_web', 'lemon8.kep_hashtag_pos_opt'], 0);
});

export const $HitKepHashtagPosForwardExp: Atom<boolean> = atom((get) => {
  const { pageType } = get($PageLevelTraffic);

  const kepExpConfig = get($SEOKepHashtagPosExp);
  return kepExpConfig === 1 && pageType === EPageType.discover;
});
